import { isBlockCheckout, isPayForOrder } from './src/util/woocommerce';
import { setupCustomHttpHeaders } from './src/util/http';
import { initClassicCheckout } from "./src/util/checkout/classicCheckout";
import { initBlockCheckout } from "./src/util/checkout/blockCheckout";
import { initPaymentCheckout } from "./src/util/checkout/paymentCheckout";

document.addEventListener(
	'DOMContentLoaded',
	setupCustomHttpHeaders,
	false
);
/**
 * Boot one of the supported checkout integrations.
 * Let us hope this list is getting shorter, not longer
 */
if ( isPayForOrder() ) {
	initPaymentCheckout()
} else if ( isBlockCheckout() ) {
	initBlockCheckout();
} else {
	initClassicCheckout()
}
